export enum Mof {
  GENERAL_FUND = 'A'
}
